import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { BuilderAdvantagesDataType } from './builderAdvantagesData'
import classes from './BuilderAdvantages.module.scss'

export const BuilderAdvantagesCard = ({
  item,
}: {
  item: BuilderAdvantagesDataType
}) => {
  const { title, subtitle, image1x, image2x, name, imageWidth, imageHeight } =
    item
  return (
    <Block variant={'solid'} r={'md'} className={classes.item}>
      <div className={classes.context}>
        <Heading as={'h3'} size={'lg'} balance center className={classes.title}>
          {title}
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          {subtitle}
        </Text>
      </div>

      <Block className={classes.visual}>
        <picture className={classes.image}>
          <source media='(min-resolution: 2dppx)' srcSet={image2x.src} />
          <img
            src={image1x.src}
            width={imageWidth}
            height={imageHeight}
            alt={name}
            loading='lazy'
          />
        </picture>
      </Block>
    </Block>
  )
}
